// Platform Settings — WhatsApp Channel/Group links + share tagline
import React, { useCallback, useEffect, useState } from 'react';
import { Save, MessageCircle } from 'lucide-react';
import { toast } from 'sonner';
import AdminShell from '../../components/admin/AdminShell';
import api from '../../utils/api';

export default function AdminPlatformSettings() {
  const [form, setForm] = useState({ whatsapp_channel_url: '', whatsapp_group_url: '', telegram_url: '', default_share_tagline: '' });
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try {
      const r = await api.get('/platform/settings');
      setForm({
        whatsapp_channel_url: r.data.whatsapp_channel_url || '',
        whatsapp_group_url: r.data.whatsapp_group_url || '',
        telegram_url: r.data.telegram_url || '',
        default_share_tagline: r.data.default_share_tagline || '',
      });
    } catch {}
  }, []);
  useEffect(() => { load(); }, [load]);

  const save = async () => {
    setBusy(true);
    try {
      await api.post('/admin/platform/settings', form);
      toast.success('✅ Settings saved');
    } catch (e) { toast.error(e?.response?.data?.detail || 'Save failed'); }
    finally { setBusy(false); }
  };

  return (
    <AdminShell>
      <div className="p-4 md:p-6 max-w-3xl mx-auto space-y-4" data-testid="admin-platform-settings">
        <div>
          <h1 className="text-2xl md:text-3xl font-black">⚙️ Platform Settings</h1>
          <p className="text-xs opacity-70">WhatsApp Channel/Group links appear in every store's share modal</p>
        </div>

        <div className="rounded-2xl bg-slate-900/70 border border-slate-800 p-4 space-y-3">
          <label className="block">
            <div className="text-[11px] font-black text-emerald-300 flex items-center gap-1 mb-1">
              <MessageCircle size={12} /> WhatsApp Channel URL
            </div>
            <input value={form.whatsapp_channel_url} onChange={(e) => setForm({ ...form, whatsapp_channel_url: e.target.value })}
                   data-testid="platform-wa-channel"
                   placeholder="https://whatsapp.com/channel/xxxx"
                   className="w-full px-3 py-2 rounded-lg bg-slate-800 border border-slate-700 text-sm" />
          </label>
          <label className="block">
            <div className="text-[11px] font-black text-emerald-300 flex items-center gap-1 mb-1">
              <MessageCircle size={12} /> WhatsApp Group URL
            </div>
            <input value={form.whatsapp_group_url} onChange={(e) => setForm({ ...form, whatsapp_group_url: e.target.value })}
                   data-testid="platform-wa-group"
                   placeholder="https://chat.whatsapp.com/xxxx"
                   className="w-full px-3 py-2 rounded-lg bg-slate-800 border border-slate-700 text-sm" />
          </label>
          <label className="block">
            <div className="text-[11px] font-black text-cyan-300 flex items-center gap-1 mb-1">
              📱 Telegram URL (optional)
            </div>
            <input value={form.telegram_url} onChange={(e) => setForm({ ...form, telegram_url: e.target.value })}
                   data-testid="platform-tg"
                   placeholder="https://t.me/xxxx"
                   className="w-full px-3 py-2 rounded-lg bg-slate-800 border border-slate-700 text-sm" />
          </label>
          <label className="block">
            <div className="text-[11px] font-black text-yellow-300 mb-1">Default share tagline (auto-added to shop shares)</div>
            <input value={form.default_share_tagline} onChange={(e) => setForm({ ...form, default_share_tagline: e.target.value })}
                   data-testid="platform-tagline"
                   placeholder="Visit my store on Anant Marketplace! 🛍️"
                   className="w-full px-3 py-2 rounded-lg bg-slate-800 border border-slate-700 text-sm" />
          </label>
          <button onClick={save} disabled={busy} data-testid="platform-save"
                  className="w-full py-2 rounded-lg bg-yellow-400 text-slate-900 font-black text-sm flex items-center justify-center gap-1 disabled:opacity-50">
            <Save size={14} /> Save Settings
          </button>
        </div>
      </div>
    </AdminShell>
  );
}
